<template>
  <form
    class="sm-form sm-form__customer-lvl1"
    @submit.prevent="handleSubmit"
  >
    <h4>Add New User</h4>
    <input-text
      v-model="formData.first_name"
      :label="'First name'"
      :name="'first_name'"
      v-validate="'required|alpha'"
      data-vv-as="First name"
      :error="errors.first('first_name')"
    />
    <input-text
      v-model="formData.last_name"
      :label="`Last name`" 
      :name="'last_name'"
      v-validate="`required|alpha`"
      data-vv-as="Last name"
      :error="errors.first('last_name')"
    />
    <input-text
      v-model="formData.email"
      :label="`Email`"
      :name="'email'"
      v-validate="`required|email`"
      data-vv-as="Email"
      :error="errors.first('email')"
      :showLoader="isEmailValidating"
      @blur="validateDBEmail()"
    />
    <btn-block
      :type="'submit'"
      :text="'Add'"
    />
  </form>
</template>

<script>
import InputText from '@/components/InputText';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'form-customer-lvl1',
  components: {
    'input-text': InputText
  },
  props: {
    backErrors: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      formData: {
        first_name: '',
        last_name: '',
        email: ''
      },
      isEmailValidating: false
    }
  },
  methods: {
    ...mapActions({
      validateAccount: 'account/validateAccount',
    }),
    handleSubmit() {
      if (this.isEmailValidating)
        return;

      this.$validator.validate()
        .then(valid => {
          if (!valid)
            return;

          this.$emit('submit', this.formData);
        })
    },
    validateDBEmail() {
      if (
        !this.formData.email.length || 
        (this.errors.first('email') && 
        !this.errors.first('email').includes(`\`${this.formData.email}\``))
      )
        return;

      this.isEmailValidating = true;
      this.validateAccount({
        email: this.formData.email
      })
        .then(() => {
          this.isEmailValidating = false;
        })
        .catch(e => {
          if (e.response.data.errors) {
            let err = e.response.data.errors;
            let msg = '';

            if (err.base) {
              msg = e.response.data.errors.base[0];
            } else {
              Object.keys(err).forEach(key => {
                msg += `${key.toUpperCase()}: ${err[key][0]}\n`;
              });
            }

            this.errors.add({
              field: 'email',
              msg
            });
          }

          this.isEmailValidating = false;
        });
    }
  },
  watch: {
    backErrors(val) {
      if (val.length)
        val.forEach(err => {
          this.errors.add(err);
        });
    },
  }
}
</script>